// TODO actual content TK
export const textContentInfo = {
	REC: {
		style: {
			copyA:
				'Imagine your reception. Is it indoors or outdoors? Is it a big celebration, or could you visit small wedding venues?',
			copyB:
				'Search for venues that fit your vision. And remember—decor can also help transform a venue into your style.',
		},
		options: {
			copyA:
				'Since every venue and package is unique, keep this info in mind when you start your venue search.',
			copyB:
				'A venue’s quoted cost is specific to your guest count, the hours you need it, and any specifics included. (Not sure? Ask for more details!)',
		},
		conversation: {
			copyA:
				'Found a venue you’re into? Reach out! Ask about their availability and see if their capacity aligns with your guest count.',
			copyB:
				'Also try The Knot’s “Request Quote” feature. It helps you decide what info to share so you can easily connect with venues.',
		},
	},
	WPH: {
		style: {
			copyA: 'Starting to think about hiring a wedding photographer?',
			copyB:
				'Kick off the search by looking for photographers whose photos you love. Browse portfolios and save any that stand out to you.',
		},
		options: {
			copyA: 'If you know your wedding date, you’re ready to begin the search.',
			copyB:
				'When considering options think about timing, how many shooters you want, who gets photo rights, and if packages are customizable.',
		},
		conversation: {
			copyA:
				"Once you've found a photographer whose look you love, it's time to learn if your personalities click. (Pun intended!)",
			copyB:
				'Reach out via The Knot\'s "Request Quote" feature, which walks you through the key pieces of info to share.',
		},
	},
	BWP: {
		style: {
			copyA: 'Ready to shop for a wedding dress, but not sure where to start?',
			copyB:
				'Before you visit salons, look at photos and save any dresses you like. Keep your venue and body type in mind to ensure the style fits your wedding.',
		},
		options: {
			copyA:
				'Once you have some style inspiration, stay open to suggestions from your bridal salon.',
			copyB:
				"Don't be shy—see if a dress is customizable and if alterations are included. Ask about upcoming trunk shows and wedding accessories like veils or jewelry.",
		},
		conversation: {
			copyA:
				'Starting to find bridal salons in your area? Reach out to schedule an appointment.',
			copyB:
				'The Knot\'s "Schedule Appointment" feature will help you share important info with bridal salons so they can prep for your visit.',
		},
	},
	DJS: {
		style: {
			copyA:
				'Deciding on music for your wedding? The Knot recommends booking a DJ that focuses on weddings.',
			copyB:
				'When searching, look for DJs who will build a playlist based on your vision (dance party, mosh-pit, or something in-between!).',
		},
		options: {
			copyA:
				'Have a specific DJ in mind? Reach out 9-12 months before your wedding. Otherwise, 6-9 months out is fine.',
			copyB:
				'Decide which events you want a DJ for. Also consider additional equipment, like microphones, you might need on your wedding day.',
		},
		conversation: {
			copyA:
				"Found a DJ you feel good about? It's time to start a conversation! Share your musical taste to see if it's a good fit.",
			copyB:
				'The Knot\'s "Request Quote" feature walks you through what to share, so your DJ has the info they need to make a custom quote.',
		},
	},
	VID: {
		style: {
			copyA:
				'Start your videographer search by thinking about how you want your wedding video to feel - cinematic or like a documentary?',
			copyB:
				'The best wedding videographers will be capturing the moments on your wedding day, and editing them to tell your story.',
		},
		options: {
			copyA:
				"Know the style you want? Now consider what parts of the day you want filmed and how many hours you'll need a videographer.",
			copyB:
				"Talk to videographers about other decisions too, like what type of music you want and whether you'll get to preview the footage.",
		},
		conversation: {
			copyA:
				"Once you've viewed some videographer portfolios, it's time to start a conversation.",
			copyB:
				'The Knot\'s "Request Quote" feature will help you answer other key questions a videographer might have before you meet.',
		},
	},
	FLO: {
		style: {
			copyA:
				'Before you look for florists, think about what kind of flowers you like. Do you prefer large centerpieces or smaller arrangements?',
			copyB:
				'The best florists will help you figure out flowers and decor that fit your wedding style and are in season.',
		},
		options: {
			copyA:
				'Know the style you like? Here are some things to consider before reaching out to florists.',
			copyB:
				'Think about which events you’ll want floral arrangements for and if you’ll need other decor like an aisle runner or votives.',
		},
		conversation: {
			copyA:
				'Found florists you’re interested in? Reach out! Share your style and see if any are the right fit.',
			copyB:
				'Try The Knot’s “Request Quote” feature. It helps you know what info to share with florists so you can easily get custom quotes.',
		},
	},
	PLN: {
		style: {
			copyA:
				'Before you look for a wedding planner, think about your wedding size, style and where you’d most like an expert’s opinion.',
			copyB:
				'Do you want help with everything or just day-of details? The best wedding planner for you will understand your style and needs.',
		},
		options: {
			copyA:
				'The type of wedding planner you hire will depend on the skills and level of support you need.',
			copyB:
				'A coordinator will step in closer to your wedding date, while a wedding planner will help you plan it all from start-to finish.',
		},
		conversation: {
			copyA:
				"Narrowed your list of potential wedding planners? It's time to get in touch.",
			copyB:
				'The Knot\'s "Request Quote" feature helps you know what to share with planners, so you can jump into talking about your style.',
		},
	},
	BEA: {
		style: {
			copyA: 'Searching for wedding hair and makeup in your area?',
			copyB:
				'Look at wedding beauty photos to get inspired. Also check out pros’ portfolios to see what looks they specialize in.',
		},
		options: {
			copyA:
				"There's some key info you'll want to consider before reaching out to beauty artists.",
			copyB:
				'Think about how many artists you’ll need, if you’d like to have a pre-wedding trial, and if you’d like them to work onsite.',
		},
		conversation: {
			copyA: "Know what you're looking for? Reach out!",
			copyB:
				'The Knot\'s "Schedule Appointment" feature helps you connect with pros so you can see if a beauty artist is the right fit.',
		},
	},
	BDS: {
		style: {
			copyA:
				'Thinking about hiring a wedding band? Start by envisioning your wedding’s vibe.',
			copyB:
				"Your wedding music sets the tone of your day, and your style will influence the type of band you'll want to hire.",
		},
		options: {
			copyA: 'If you’re searching for bands, consider these things.',
			copyB:
				'Think about the events you’ll need them for, what songs are on your list, and try to hear the band—or see them live!—before making a decision.',
		},
		conversation: {
			copyA:
				"Found a wedding band whose sound you love? Reach out and share your musical taste to see if it's a good fit.",
			copyB:
				'The Knot\'s "Request Quote" feature walks you through what to share so that your band has the info they need.',
		},
	},
	CAT: {
		style: {
			copyA:
				'Ready to plan your wedding food? Think about the style of your event.',
			copyB:
				"Whether you're having a sit-down dinner, buffet or passed apps, your menu should reflect the style of your wedding.",
		},
		options: {
			copyA:
				'Need to hire a caterer? The best caterers book up to 12 months in advance.',
			copyB:
				'Catering involves more than just food. Explore menus and ask about presentation, along with what’s included in catering costs.',
		},
		conversation: {
			copyA:
				'Found potential caterers? Start a conversation to learn more and set up a tasting.',
			copyB:
				'The Knot\'s "Request Quote" feature shares your key info with caterers so they can send you their best packages.',
		},
	},
};
